import React from 'react'
import { useTranslation } from 'react-i18next'
import coinStack from 'assets/coin-stack.svg'
import StageContent from './common/StageContent'
import StageFooter from './common/StageFooter'
import StageHeader from './common/StageHeader'
import Button from 'features/common/components/Button'
import StepProgressBar from 'features/common/components/StepProgressBar'
import useStripeLink from '../../common/hooks/useEmailCode/useStripeLink'

export const StripeStage = () => {
    const { t } = useTranslation()
    const { redirectToStripe, } = useStripeLink()

    return (
        <div className="flex flex-1 flex-col">
            <StageHeader>{t('ONBOARDING_STEP_STRIPE')}</StageHeader>
            <StageContent>
                <img src={coinStack} alt="stripe" />
                <div className="whitespace-pre-wrap text-center text-[2.5rem] font-bold text-yellow-30">
                    {t('ONBOARDING_STRIPE_DESCRIPTION')}
                </div>
                <div className="mb-2">
                    <Button
                        className="rounded-full py-4 px-8"
                        onClick={redirectToStripe}
                    >
                        {t('ONBOARDING_GO_TO_STRIPE')}
                    </Button>
                </div>
            </StageContent>
            <StageFooter>
                <StepProgressBar
                    points={[
                        {
                            title: t('ONBOARDING_STEP_REGISTRATION'),
                            status: 'success',
                        },
                        { title: t('ONBOARDING_STEP_EMAIL'), status: 'success' },
                        { title: t('ONBOARDING_STEP_STRIPE'), status: 'current' },
                    ]}
                />
            </StageFooter>
        </div>
    )
}

export default StripeStage
